var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5584 12.7251C13.4261 11.7546 12.7791 10.3527 12.7791 8.89681V6.79393C12.7791 4.15185 10.8379 1.94112 8.24977 1.6176V0.754881C8.24977 0.32352 7.92625 0 7.49489 0C7.06353 0 6.74001 0.32352 6.74001 0.754881V1.56368C4.20577 1.94112 2.21072 4.09793 2.21072 6.74001V8.84289C2.21072 10.3527 1.56368 11.7546 0.431361 12.7251C0.16176 12.9947 0 13.3183 0 13.6957C0 14.3967 0.593121 14.9898 1.29408 14.9898H13.6957C14.3967 14.9898 14.9898 14.3967 14.9898 13.6957C15.0437 13.3183 14.8819 12.9947 14.5584 12.7251Z",
    fill: "#BF212B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49602 18.063C8.84402 18.063 9.97634 17.0924 10.2459 15.7983H4.74609C5.01569 17.0924 6.14802 18.063 7.49602 18.063Z",
    fill: "#BF212B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.5df5d2c65a2dd883ca3c204c5e714f85.svg";
export { ForwardRef as ReactComponent };